export const VERSION_FEED_URL =
  process.env.REACT_APP_VERSION_FEED ||
  'https://micronaut.io/launch/mn-version-feed.json'
